var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cs-notfound",
      class: { "cs-notfound-container": !_vm.isPage },
    },
    [
      _c("div", { staticClass: "cs-notfound-content" }, [
        _vm.isPage
          ? _c(
              "div",
              { staticClass: "cs-notfound--header" },
              [
                _c(
                  "h1",
                  {
                    attrs: { tabindex: "0" },
                    on: { keydown: _vm.onKeydownTitle },
                  },
                  [_vm._v(_vm._s(_vm.errorPageTitle))]
                ),
                _vm.$accessibilityMode()
                  ? _c("cs-skip-link", {
                      attrs: {
                        show: _vm.showSkipLink,
                        title: "Skip to homepage",
                        url: "/",
                      },
                      on: {
                        "on-blur": function ($event) {
                          _vm.showSkipLink = false
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _c("div", { staticClass: "cs-notfound-code-container" }, [
              _c("span", { staticClass: "cs-notfound-code" }, [
                _c("span", { staticClass: "cs-fg-primary" }, [
                  _vm._v(_vm._s(_vm.status)),
                ]),
              ]),
              _c("img", {
                staticClass: "cs-notfound-image",
                attrs: {
                  src: _vm.errorImage,
                  alt: _vm.$translateWithDefault("notFound.sadFace"),
                },
              }),
            ]),
        _c("div", { staticClass: "cs-notfound--body" }, [
          _vm.isPage
            ? _c("p", {
                staticClass: "cs-notfound-message",
                domProps: { innerHTML: _vm._s(_vm.errorPageMessage) },
              })
            : _c("p", { staticClass: "cs-notfound-message" }, [
                _vm._v(
                  _vm._s(
                    _vm.$translateWithDefault(
                      "componentNotFoundMessage",
                      _vm.errorMessage
                    )
                  )
                ),
              ]),
          _c("div", { staticClass: "cs-notfound-homelink" }, [
            _c(
              "button",
              {
                staticClass: "cs-button cs-bg-primary",
                class: { "cs-bg-accent-accessible": _vm.$accessibilityMode() },
                attrs: {
                  type: "button",
                  title: _vm.$translateWithDefault("notFound.homeLink"),
                },
                on: {
                  click: function ($event) {
                    return _vm.$router.replace("/")
                  },
                },
              },
              [
                _c("font-awesome-icon", {
                  attrs: {
                    icon: ["fal", "home"],
                    title: _vm.$translateWithDefault("notFound.housePic"),
                  },
                }),
                _vm._v(
                  " " +
                    _vm._s(_vm.$translateWithDefault("notFound.goHome")) +
                    " "
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }